const TAB_KEYS = [
    "customerProfile", "regularIncome", "moneyFlow", "amountDistribution",
    "contactNetwork", "anomalyDetection", "temporalBehavior", "transactionVelocity",
    "structuringDetection", "dormancyAnalysis",
    "layeringDetection", "behavioralDeviation", "cashTransactions"
];

const getDefaultDateRange = () => {
    const today = new Date();
    const twelveMonthsAgo = new Date(today.getFullYear(), today.getMonth() - 12, today.getDate());
    const pad = (n) => String(n).padStart(2, "0");
    return {
        startDate: `${pad(twelveMonthsAgo.getDate())}.${pad(twelveMonthsAgo.getMonth() + 1)}.${twelveMonthsAgo.getFullYear()}`,
        endDate: `${pad(today.getDate())}.${pad(today.getMonth() + 1)}.${today.getFullYear()}`
    };
};

const buildTabMap = (defaultValue) => Object.fromEntries(TAB_KEYS.map((k) => [k, defaultValue]));

const state = () => ({
    customers: [],
    dateRange: getDefaultDateRange(),
    activeTab: 0,
    analysisMode: "profile-summary",
    analysisResults: buildTabMap(null),
    analysisIds: buildTabMap(null),
    loadingMap: buildTabMap(false),
    progressMap: buildTabMap(0),
    analysisParameters: {
        customerProfile: { lookbackMonths: 12 },
        regularIncome: { minRecurrence: 3, toleranceDays: 5, minAmount: 0, periodHint: "auto" },
        moneyFlow: { timeGranularity: "monthly", largeTransactionThreshold: 50000, minFlowCount: 3 },
        amountDistribution: { digitPosition: "first", transactionType: "all", significanceLevel: 0.05 },
        contactNetwork: { minTransactionCount: 3, minTotalAmount: 0, maxHops: 1, beta1: 0.4, beta2: 0.4, beta3: 0.2 },
        anomalyDetection: { method: "hybrid", zThreshold: 2.0, iqrMultiplier: 1.5, windowSize: 12, timeGranularity: "weekly" },
        temporalBehavior: { analysisWindow: "12m", includeWeekends: true, channelFilter: ["all"] },
        transactionVelocity: { baselinePeriodWeeks: 12, velocityMultiplier: 3.0, metric: "both", granularity: "daily" },
        structuringDetection: { reportingThreshold: 75000, windowDays: 7, minFragments: 3, proximityPercent: 15 },
        dormancyAnalysis: { dormancyThresholdDays: 90, minReactivationAmount: 0 },
        layeringDetection: { maxHops: 5, maxChainDays: 30, amountDecayTolerance: 10, minChainAmount: 10000 },
        behavioralDeviation: { baselinePeriodMonths: 6, comparisonPeriodMonths: 3 },
        cashTransactions: {}
    },
    activePollers: {},
    backendMessages: buildTabMap(null),
    multiHopResults: null,
    multiHopLoading: false,
    connectionPaths: [],
    connectionLoading: false,
    narrativeData: null,
    insightCards: []
});

export { TAB_KEYS };
export default state;
